<script>
    import {PATH_PREFIX} from '../../../../apiUrls.js';
    import {sgettext} from '../../../../i18n.js';

    export let row = null;
</script>

<style>

</style>

<a href={`${PATH_PREFIX}/sw/common/issues/${row.id}/`} target="_blank" rel="noopener noreferrer"
   class="d-inline-block pt-2">
    {row.value? row.value : sgettext('$$DESCRIPTION_AVAILABLE$$')}
</a>